import styled from 'styled-components'
import { Progress } from 'antd'
import { ProgressProps } from 'antd/lib/progress'
import { Card as CardComponent } from 'src/components/Ant'

export const WrapCard = styled(CardComponent)`
  margin-bottom: 16px;
`

export const WrapProgress = styled(Progress)<ProgressProps>`
  margin-bottom: 24px;
`
